const { z, HumanisedBooleanLike } = require('@reckon-web/next-config/client');

/**
 * @type {import('./__generated__/config').ConfigEnv}
 */
module.exports = {
  APPLICATION_LONG_DISPLAY_NAME: z.string().default('Reckon Portal'),
  APPLICATION_SHORT_DISPLAY_NAME: z.string().default('portal;'),
  APPLICATION_LOCALSTORAGE_PREFIX: z.string().default('Portal'),

  APPLICATION_PORTAL_LEGACY_REST_API_TOKEN_KEY: z.string().default('token'),
  APPLICATION_PORTAL_REST_API_URL: z
    .string()
    .default('https://portal-backend.dev.reckoncloud.com.au'),
  APPLICATION_PORTAL_LOGIN_URL: z.string().default('/'),
  APPLICATION_APOLLO_CLIENT_API_URL: z
    .string()
    .default('https://graphql.dev.reckonapi.com/graphql'),

  APPLICATION_STRIPE_REGION_STORAGE_KEY: z.string().default('region'),
  APPLICATION_STRIPE_PUBLIC_KEY_AU: z
    .string()
    .default('pk_test_wPiDWWchyfyrtg2c0YWRiVYF'),
  APPLICATION_STRIPE_PUBLIC_KEY_NZ: z
    .string()
    .default('pk_test_50LcoGTbOPlmLcwLrty93eC1'),
  APPLICATION_STRIPE_PUBLIC_KEY_GB: z
    .string()
    .default('pk_test_hu4yo6ACm7UP9vSCGFdxMLTK'),

  APPLICATION_SENTRY_DSN: z
    .string()
    .default(
      'https://4b36d2e2d6819e1f1582892497f8c925@o378482.ingest.sentry.io/4505949165780992'
    ),
  APPLICATION_GOOGLE_GTM_APIKEY: z.string().default('GTM-TLRWFL5'),
  APPLICATION_GOOGLE_GOOGLE_ANALYTICS_KEY: z.string().default(''),
  APPLICATION_BRANCHIO_APIKEY: z
    .string()
    .default('key_live_epO32AAOR41gZBKmOMyvSmfjrza0Er2G'),
  APPLICATION_HEAPIO_APPID: z.string().default(''),
  APPLICATION_INTERCOM_APPID: z.string().default(''),
  APPLICATION_INTERCOM_APPNAME: z.string().default('PORTAL_WEB'),
  APPLICATION_APPCUES_APPID: z.string().default(''),

  APPLICATION_FEATUREFLAG_FAKECHECKOUTLAUNCHER: HumanisedBooleanLike.default(
    false
  ),

  APPLICATION_GENERAL_HELPARTICLE_URL: z
    .string()
    .default('https://help.reckon.com/category/a5pr5de69c-reckon-one-how-to'),
  APPLICATION_PORTAL_LEGACY_PRODUCT_CONFIGURATION_URL: z
    .string()
    .default('https://genesis.dev.reckoncloud.com.au/'),
  APPLICATION_PRODUCTHELP_INSIGHTS_URL: z
    .string()
    .default('https://help.reckon.com/article/mclkrazvrc'),
  APPLICATION_PRODUCTHELP_RECKONE_URL: z
    .string()
    .default('https://help.reckon.com/category/jhqf28eyqu-reckon-one'),
  APPLICATION_PRODUCTHELP_PAYROLL_URL: z
    .string()
    .default(
      'https://help.reckon.com/category/e1z2o95gyc-reckon-payroll-premier'
    ),
  APPLICATION_PRODUCTINFORMATION_INSIGHTS_URL: z
    .string()
    .default('https://www.reckon.com/au/financial-reporting-software/'),
  APPLICATION_PRODUCTINFORMATION_INSIGHTS_CONFIGURATION_URL: z
    .string()
    .default('/#/insights'),
  APPLICATION_PRODUCTINFORMATION_INSIGHTS_TERMSANDCONDITIONS_URL: z
    .string()
    .default('https://www.reckon.com/au/terms/reckon-insights'),
  APPLICATION_PRODUCTINFORMATION_INSIGHTS_SUBSCRIPTIONCONDITIONS_URL: z
    .string()
    .default('https://www.reckon.com/au/terms/reckon-insights'),
  APPLICATION_PRODUCTINFORMATION_INVOICES_URL: z
    .string()
    .default('https://mksba.app.link/QcsNnoTDAob'),
  APPLICATION_RECKON_LOGO_URL: z
    .string()
    .default(
      'https://images.dev.reckoncloud.com.au/images/ReckonApplicationLogo.svg'
    ),
  APPLICATION_RECKON_MATE_LOGO_URL: z
    .string()
    .default(
      'https://images.dev.reckoncloud.com.au/images/ReckonMateApplicationLogo.svg'
    ),
};
